export default function Quotes(props:{children?:any, classNames?:string}){
    return <div className={`bg-slate-500/60 rounded-lg p-5 text-white ${props.classNames ? props.classNames : ""}`}>
        {props.children}
    </div>
}